module.exports = __webpack_public_path__ + "5.0.2/img/car_01.098bc901.png";